module.exports = __webpack_public_path__ + "img/Fattoush Salad with Cucumber and Tomato.b864f941.png";